import FooterNavbar from "../../../../footernavbar/FooterNavbar";
import AboutusNavbar from "../AboutusNavbar";

const Ethics = () => {
  return (
    <>
      <div className=" display-max">
        <FooterNavbar />
        <AboutusNavbar />
        <div>
          <div>
            <div className="mt-3 py-3">
              <div className="row">
                <div className="container">
                  <div className="col-lg-12 justify-content-center text-center ">
                    <span className="badge rounded-pill badge-info text-capitalize mb-0">
                      Ethics
                    </span>
                    <h1 className=" text-black source-serif-4 text-normal mt-2">
                      <sup>
                        {" "}
                        <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                      </sup>
                      Building Trust Through Integrity{" "}
                      <sup>
                      <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                      </sup>
                    </h1>
                  </div>
                </div>
              </div>
              <div className="w-60 h-50 mx-auto mt-4">
                <div className="d-block blur-shadow-image">
                  <img
                    src="../../assets/img/footer/ethics-1.jpeg"
                    alt="img-blur-shadow-blog-2"
                    className="img-full "
                    loading="lazy"
                  />
                </div>
              </div>
            </div>

            <div className="row w-70 d-flex justify-content-center mx-auto pt-0">
              <section className="py-0">
                <div className="container">
                  <div className="row align-items-center">
                    <div className="container col-lg-12  col-md-6 position-relative mb-sm-0 mb-3">
                      <p className="mb-3 fs-2 container text-black text-center">
                        At Sworld solutions private limited, ethics form the
                        cornerstone of our operations. We understand that trust
                        is earned through transparent and ethical practices, and
                        we are committed to upholding the highest standards in
                        everything we do.
                      </p>
                    </div>
                  </div>
                </div>
              </section>
              <section className="py-3">
                <div className="container">
                  <div className="row justify-space-between py-2">
                    <div className="card card-plain card-blog mt-5">
                      <div className="row">
                        <div className="col-md-6 my-auto ms-md-3 mt-md-auto mt-4">
                          <h3 className="text-dark cursor-pointer">
                            {" "}
                            Customer Commitment
                          </h3>
                          <p className="fs-5 text-black">
                            Our customers are at the center of our ethical
                            framework. We pledge to always prioritize their
                            interests and satisfaction above all else. From the
                            quality of our products to the security of their
                            personal information, we strive to exceed
                            expectations and ensure a seamless shopping
                            experience.
                          </p>
                        </div>
                        <div className="col-md-5">
                          <div className="card-image position-relative border-radius-lg cursor-pointer">
                            <div className="blur-shadow-image">
                              <img
                                className="img border-radius-lg"
                                src="../../assets/img/footer/customer-commitment.jpeg"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section className="py-3">
                <div className="container">
                  <div className="row justify-space-between py-2">
                    <div className="card card-plain card-blog mt-5">
                      <div className="row">
                        <div className="col-md-5">
                          <div className="card-image position-relative border-radius-lg cursor-pointer">
                            <div className="blur-shadow-image">
                              <img
                                className="img border-radius-lg"
                                src="../../assets/img/footer/supplier-relation.jpg"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 my-auto ms-md-3 mt-md-auto mt-4">
                          <h3 className="text-dark cursor-pointer">
                            {" "}
                            Supplier Relationships
                          </h3>
                          <p className="fs-5 text-black">
                            We believe in nurturing strong, fair, and respectful
                            relationships with our suppliers. By partnering with
                            suppliers who share our values of integrity and
                            accountability, we ensure that every product we
                            offer meets rigorous ethical standards—from sourcing
                            to delivery.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section className="py-3">
                <div className="container">
                  <div className="row justify-space-between py-2">
                    <div className="card card-plain card-blog mt-5">
                      <div className="row">
                        <div className="col-md-5">
                          <div className="card-image position-relative border-radius-lg cursor-pointer">
                            <div className="blur-shadow-image">
                              <img
                                className="img border-radius-lg"
                                src="../../assets/img/footer/honesty.jpg"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 my-auto ms-md-3 mt-md-auto mt-4">
                          <h3 className="text-dark cursor-pointer">
                            {" "}
                            Transparency and Honesty
                          </h3>
                          <p className="fs-5 text-black">
                            Transparency is key to building lasting
                            relationships with our customers and stakeholders.
                            We provide clear and accurate information about our
                            products, pricing, and policies, empowering
                            consumers to make informed choices. We openly
                            communicate about our practices, successes, and
                            challenges, demonstrating our commitment to honesty
                            in all aspects of our business.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section className="py-3">
                <div className="container">
                  <div className="row justify-space-between py-2">
                    <div className="card card-plain card-blog mt-5">
                      <div className="row">
                        <div className="col-md-5">
                          <div className="card-image position-relative border-radius-lg cursor-pointer">
                            <div className="blur-shadow-image">
                              <img
                                className="img border-radius-lg"
                                src="../../assets/img/footer/data-seccurity.jpg"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 my-auto ms-md-3 mt-md-auto mt-4">
                          <h3 className="text-dark cursor-pointer">
                            {" "}
                            Privacy and Data Security
                          </h3>
                          <p className="fs-5 text-black">
                            Protecting our customers' privacy and data security
                            is non-negotiable. We adhere strictly to data
                            protection regulations and industry best practices
                            to safeguard personal information. Our commitment to
                            privacy extends across every transaction and
                            interaction, ensuring confidentiality and
                            trustworthiness at all times.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section className="py-3">
                <div className="container">
                  <div className="row justify-space-between py-2">
                    <div className="card card-plain card-blog mt-5">
                      <div className="row">
                        <div className="col-md-6 my-auto ms-md-3 mt-md-auto mt-4">
                          <h3 className="text-dark cursor-pointer">
                            {" "}
                            Social Responsibility
                          </h3>
                          <p className="fs-5 text-black">
                            Beyond profit, we recognize our responsibility to
                            contribute positively to society. Through charitable
                            initiatives, community engagement, and sustainable
                            practices, we strive to make a meaningful impact on
                            the communities we serve. We believe in giving back
                            and supporting causes that align with our values and
                            resonate with our customers.
                          </p>
                        </div>
                        <div className="col-md-5">
                          <div className="card-image position-relative border-radius-lg cursor-pointer">
                            <div className="blur-shadow-image">
                              <img
                                className="img border-radius-lg"
                                src="../../assets/img/footer/social-response.jpg"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section className="py-3">
                <div className="container">
                  <div className="row justify-space-between py-2">
                    <div className="card card-plain card-blog mt-5">
                      <div className="row">
                        <div className="col-md-6 my-auto ms-md-3 mt-md-auto mt-4">
                          <h3 className="text-dark cursor-pointer">
                            {" "}
                            Employee Well-being
                          </h3>
                          <p className="fs-5 text-black">
                            Our team is our greatest asset, and we prioritize
                            their well-being and professional growth. We foster
                            a workplace culture based on fairness, diversity,
                            and respect, where every employee has the
                            opportunity to thrive and contribute to our ethical
                            mission. By investing in our team, we ensure a
                            motivated and dedicated workforce committed to
                            upholding our ethical standards.
                          </p>
                        </div>
                        <div className="col-md-5">
                          <div className="card-image position-relative border-radius-lg cursor-pointer">
                            <div className="blur-shadow-image">
                              <img
                                className="img border-radius-lg"
                                src="../../assets/img/footer/employee-wellbeing.jpg"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section className="py-3">
                <div className="container">
                  <div className="row justify-space-between py-2">
                    <div className="card card-plain card-blog mt-5">
                      <div className="row">
                        <div className="col-md-6 my-auto ms-md-3 mt-md-auto mt-4">
                          <h3 className="text-dark cursor-pointer">
                            {" "}
                            Continuous Improvement
                          </h3>
                          <p className="fs-5 text-black">
                            Ethics is not a static concept—it requires constant
                            evaluation and improvement. We actively seek
                            feedback from our customers, employees, and
                            stakeholders to refine our practices and enhance our
                            ethical framework. By embracing innovation and
                            learning from our experiences, we remain agile and
                            responsive to ethical challenges and opportunities.
                          </p>
                        </div>
                        <div className="col-md-5">
                          <div className="card-image position-relative border-radius-lg cursor-pointer">
                            <div className="blur-shadow-image">
                              <img
                                className="img border-radius-lg"
                                src="../../assets/img/footer/improvement.jpg"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div className="mt-3 py-7">
              <div className="row">
                <div className="container">
                  <div className="col-lg-12 justify-content-center text-center ">
                    <h1 className=" text-black source-serif-4 text-normal mt-2">
                      <sup>
                      <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                      </sup>{" "}
                      Join Us in Upholding Ethics
                      <sup>
                      <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                      </sup>
                    </h1>
                    <h4 className=" text-black source-serif-4 text-normal mt-2">
                      <sup>
                      <i
                      className="ri-double-quotes-l text-dark text-xs"
                      aria-hidden="true"
                    ></i>{" "}
                      </sup>
                      At Sworld solutions private limited, ethics are more than
                      a commitment—they are a promise to uphold integrity,
                      transparency, and responsibility in everything we do.{" "}
                      <br /> Join us in creating a community built on trust and
                      ethical values, where every transaction reflects our
                      dedication to doing what's right.
                      <br /> Together, we can set a higher standard for ethical
                      commerce and make a positive impact on the world.
                      <sup>
                        {" "}
                        <i
                      className="ri-double-quotes-r text-dark text-xs"
                      aria-hidden="true"
                    ></i>{" "}
                      </sup>
                    </h4>
                  </div>
                </div>
              </div>
              <div className="w-60 h-50 mx-auto mt-4">
                <div className="d-block blur-shadow-image">
                  <img
                    src="../../assets/img/footer/ethics.jpg"
                    alt="img-blur-shadow-blog-2"
                    className="img-full "
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Ethics;
